<template>
  <div>
    <div>
      <a
        v-if="user && user.role === UserRoleEnum.ADMIN"
        target="_blank"
        :href="`/data-ui/Email/${value.id}`"
      >
        {{ value.subject }}
      </a>
      <span v-else>{{ value.subject }}</span>
      <b-button
        @click="details = !details"
        size="sm"
        variant="link"
        class="gid-feed__details p-0 align-baseline ml-1 text-secondary"
      >
        <small v-if="!details">view email</small>
        <small v-else>hide email</small>
      </b-button>
    </div>
    <div class="text-muted">
      <small>To: {{ value.to.join(',') }}</small>
    </div>
    <div v-if="value.attachments.length">
      <small class="text-muted">
        Attachments:
        <span v-for="a in value.attachments" :key="a.url">
          <BIconFileEarmark />
          <CrudLink :value="a.url" :disabled="true" :linkText="true" />
        </span>
      </small>
    </div>
    <iframe
      v-if="details"
      ref="iframeRef"
      :srcdoc="value.bodyHtml"
      class="w-100 border rounded"
      @load="adjustIframeHeight"
    ></iframe>
  </div>
</template>

<script>
import axios from 'axios';
import { BIconFileEarmark } from 'bootstrap-vue';
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';
import CrudLink from '../crud-list/CrudLink.vue';
import { mapGetters } from 'vuex';
import { UserRoleEnum } from '@gid/models';

export async function fetchEmails({ job: { sfid: jobSfid }, env }) {
  const emails = [];
  const qb = RequestQueryBuilder.create();
  const jobSearch = {
    'jobs.id': { [CondOperator.EQUALS]: jobSfid },
  };
  const excludeUnassignedJobsEmails = {
    template: { [CondOperator.NOT_EQUALS]: 'admin/unassigned_jobs' },
  };
  const excludedEmails =
    env === 'production'
      ? [
          { to: { [CondOperator.EXCLUDES_LOW]: '@getitdone.rocks' } },
          { to: { [CondOperator.EXCLUDES_LOW]: '@getitdone.co' } },
        ]
      : [];

  const jobsQuery = qb
    .search({
      $and: [jobSearch, excludeUnassignedJobsEmails, ...excludedEmails],
    })
    .query();
  emails.push(
    ...(await axios.get(`/data-api/entity/email/?${jobsQuery}`)).data,
  );

  const accountingDocuments = await axios
    .get(
      `/data-api/entity/accounting-document/?${qb.search(jobSearch).query()}`,
    )
    .then(({ data }) => data.map((d) => d.id));

  if (accountingDocuments.length > 0) {
    const accDocsQuery = qb
      .search({
        $and: [
          {
            'accountingDocuments.id': {
              [CondOperator.IN]: accountingDocuments,
            },
          },
          ...excludedEmails,
        ],
      })
      .query();
    emails.push(
      ...(await axios.get(`/data-api/entity/email/?${accDocsQuery}`)).data,
    );
  }

  return emails.map((value) => ({
    time: new Date(value.timestamp),
    value,
  }));
}

export default {
  components: {
    BIconFileEarmark,
    CrudLink,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      UserRoleEnum,
      details: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    adjustIframeHeight() {
      this.$nextTick(() => {
        const iframe = this.$refs.iframeRef;
        if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
          iframe.style.height =
            iframe.contentWindow.document.documentElement.scrollHeight +
            10 +
            'px';
        }
      });
    },
  },
};
</script>
